import React from 'react';

const ValidationSummary: React.FC<{ messages: string[] }> = ({ messages }) => {
  if (!messages.length) return null;
  return (
    <div className="mt-2">
      {messages.map((m, i) => (
        <div key={i} className="text-danger small">
          • {m}
        </div>
      ))}
    </div>
  );
};

export default ValidationSummary;
